export default {
  name: "ContactSeparator"
}